module.exports = __webpack_public_path__ + "img/wedding2.396a58ac.jpg";